// Prosty helper do RegExp na pathname:
const r = (regex) => (pathname) => regex.test(pathname);

export const routes = [
    // /student (dashboard)
    {
        test: r(/^\/student\/?$/),
        steps: [
            { selector: '[data-tour="student-title"]',    content: 'Witaj w panelu studenta Elektronicznej platformy egzaminowania Wyższej Szkoły Zdrowia w Gdańsku' },
            { selector: '[data-tour="student-upcoming"]', content: 'Poniżej wyświetlają się najbliższe terminy. Aby zobaczyć wszystkie wejdź w nadchodzące terminy.' },
            { selector: '[data-tour="student-actions"]',  content: 'Tu masz dostęp do nadchodzących i zakończonych egzaminów oraz Twoich grup. Jeżeli prowadzący wyrazi zgodę na podejście do egzaminu z inną grupą, otrzymasz od niego kod, który należy tu wpisać, aby dołączyć do egzaminu za pomocą kodu..' },
        ],
    },

    // Start egzaminu — obsłuż obie konwencje ścieżek
    { // /student/egzamin/termin/:termId/start
        test: r(/^\/student\/egzamin\/termin\/[^/]+\/start\/?$/),
        steps: [
            { selector: '[data-tour="seb-download"]',     content: 'Pobierz przeglądarkę SEB i zainstaluj na swoim urządzeniu.' },
            { selector: '[data-tour="seb-link"]',     content: 'Pobierz plik SEB i otwórz. Plik poninien automatycznie otworzyć się w przeglądarce Safe Exam Browser.' },
            { selector: '[data-tour="seb-help"]',     content: 'Problemy z SEB? Wyślij wiadomość z załącznikiem.' },
            { selector: '[data-tour="start-button"]', content: 'Tu rozpoczniesz egzamin, gdy wybije czas.' },
        ],
    },
    { // /egzamin/:termId (jeśli masz też taką trasę)
        test: r(/^\/egzamin\/[^/]+\/?$/),
        steps: [
            { selector: '[data-tour="seb-link"]',     content: 'Pobierz plik SEB, jeśli jest wymagany.' },
            { selector: '[data-tour="seb-help"]',     content: 'Problemy z SEB? Wyślij wiadomość z załącznikiem.' },
            { selector: '[data-tour="start-button"]', content: 'Tu rozpoczniesz egzamin, gdy wybije czas.' },
        ],
    },

    // Poczekalnia: /egzamin/:attemptId/oczekiwanie (i wariant student/)
    {
        test: r(/^\/(?:student\/)?egzamin\/[^/]+\/oczekiwanie\/?$/),
        steps: [
            { selector: '[data-tour="countdown"]', content: 'Odliczanie czasu do startu.' },
            { selector: '[data-tour="camera"]',    content: 'Wybierz i sprawdź kamerę. Pamiętaj, ze musisz pozwolić na udostępnienie kamery i mikrofonu w przeglądarce. Jeżeli ekran dalej jest czarny przeładuj i zrób reset wyboru.' },
            { selector: '[data-tour="consents-camera"]',  content: 'Zaznacz wymagane zgody, aby przejść dalej.' },
            { selector: '[data-tour="micro"]',     content: 'Włącz i sprawdź mikrofon — pasek reaguje na głos.' },
            { selector: '[data-tour="consents-micro"]',  content: 'Zaznacz wymagane zgody, aby przejść dalej.' },
            { selector: '[data-tour="weryfikacja"]',  content: 'Przejdź dalej do etapu weryfikacji.' },
        ],
    },

    // Weryfikacja: /egzamin/:attemptId/weryfikacja (i wariant student/)
    {
        test: r(/^\/(?:student\/)?egzamin\/[^/]+\/weryfikacja\/?$/),
        steps: [
            { selector: '[data-tour="face-oval"]', content: 'Ustaw twarz w owalu i spójrz w kamerę.' },
            { selector: '[data-tour="snap"]',      content: 'Zrób zdjęcie a następnie wyślij do weryfikacji.' },
        ],
    },

    // Przebieg egzaminu: /egzamin/:attemptId/trwa i /student/egzamin/:attemptId/trwa
    {
        test: r(/^\/(?:student\/)?egzamin\/[^/]+\/trwa\/?$/),
        steps: [
            { selector: '[data-tour="timer"]',      content: 'Licznik czasu. Po upływie limitu egzamin zakończy się automatycznie.' },
            { selector: '[data-tour="grid"]',       content: 'Siatka pytań — zielone = odpowiedź zapisana.' },
            { selector: '[data-tour="next"]',       content: '„Następne/Poprzednie" zapisuje i przechodzi dalej lub do poprzedniego.' },
            { selector: '[data-tour="finish"]',     content: '„Zakończ egzamin” — finalizacja i wysłanie odpowiedzi.' },
        ],
    },
];

export function matchSteps(pathname) {
    for (const r of routes) if (r.test(pathname)) return r.steps;
    return [];
}
